// 流转记录
<template>
  <div>
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{
        fixed: true,
      }"
      :getDataConfig="dataQueryFunc()"
      :updateDataTag="updateDataTag"
    >
    </tablePageComp>
  </div>
</template>

<script>
export default {
  props: ["contractProp"],
  data() {
    return {
      dataList: [],
      columnsList: [
        {
          label: "日期",
          prop: "time",
          width: 200,
        },
        {
          label: "内容",
          prop: "text",
        },
      ],
      updateDataTag: false,
      totalCount: 0,
    };
  },
  methods: {
    dataQueryFunc() {
      //查询条件
      let paramObj = {
        customerId: this.contractProp.customer_id,
      };
      return {
        apiName: "circRecordFunc",
        paramObj,
        success: function(response, callBack) {
          // console.log(response)
          let records = response.data.data.List;
          let arr = [];
          for (let i = 0; i < records.length; i++) {
            let obj = records[i];
            let standardObj = {};
            for (let key in standardObj) {
              if (obj[key] == null || obj[key] == undefined) {
                obj[key] = "";
              }
            }
            arr.push(obj);
          }

          // 数据列表---更新
          this.dataList = arr;
          // 数据总条数---更新
          // this.totalCount = response.data.data.totalCount//接口返回的数据总条数

          // 回调函数
          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function(error, callBack) {
          // 回调函数
          if (callBack) {
            callBack();
          }
        },
      };
    },
  },
};
</script>

<style></style>
